import { Pipe, type PipeTransform } from '@angular/core';
import type { ActiveUser } from '../../shared/models/api/user.model';

@Pipe({
  name: 'opaFilterSelectedUsers',
  standalone: true,
})
export class FilterSelectedUsersPipe implements PipeTransform {
  transform(users: ActiveUser[], selectedUserIds: string | null): ActiveUser[] {
    const selected = selectedUserIds?.split(',') ?? [];
    return users.filter((user) => !selected.includes(`${user.id}`));
  }
}
